/*
  vcz-cart.js — VCZ cart drawer v2 (Broadcast)
  Carregar DEPOIS do theme.js:  <script src="{{ 'vcz-cart.js' | asset_url }}" defer></script>

  Princípio: o Liquid é a fonte de verdade. Este ficheiro só:
    1. Remove um grupo inteiro (_vcz_group) num único /cart/update.js
    2. Encaminha o "Add" do upsell para o pipeline do tema (theme:cart:add)
    3. Toggle do Gift Bag (+ limpeza se ficar órfão; ligado por predefinição com opt-out por sessão)
    4. Secção Discounts: escolher / trocar / remover via cart-items.updateCartDiscounts
    5. Patch ao cart-items.build(): copia as partes VCZ do api-cart-items e
       corrige o limite de portes grátis (cêntimos na moeda do mercado)
    6. Contador de reserva (sessionStorage, 1 vez por sessão)
    7. Data estimada de envio (Lisboa, hora de corte, dias úteis, feriados)
    8. Compatibilidade com o personalizador: agrupa (_vcz_group) os itens de um mesmo
       "Add to cart" e refresca/abre o drawer do tema depois do add
    9. Guarda de moeda: se o carrinho estiver noutra moeda que a página (cookie de mercado
       desatualizado), reafirma o país da página e refresca o drawer
*/
(function () {
  'use strict';

  const cartItems = () => document.querySelector('cart-items');
  const cartDrawer = () => document.querySelector('cart-drawer') || document.querySelector('[data-cart-page]');
  const refresh = () => document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

  function setLoading() {
    const c = cartDrawer();
    if (c) c.classList.add('is-loading');
    const ci = cartItems();
    if (ci && typeof ci.disableCartButtons === 'function') { try { ci.disableCartButtons(); } catch (e) {} }
  }

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || ('HTTP ' + res.status));
    return data;
  }

  /* ── 1. Remover grupo inteiro ── */
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-item-remove][data-group-keys]');
    if (!a) return;
    const keys = (a.dataset.groupKeys || '').split(',').map((k) => k.trim()).filter(Boolean);
    if (keys.length < 2) return;                 // uma linha só → o tema trata
    e.preventDefault();
    e.stopImmediatePropagation();                // impede o handler do tema (só apagaria 1 linha)
    if (a.hasAttribute('disabled')) return;
    setLoading();
    const updates = {};
    keys.forEach((k) => { updates[k] = 0; });
    try { await post('/cart/update.js', { updates }); }
    catch (err) { console.error('VCZ remove group:', err); }
    refresh();
  }, true);

  /* ── 2. Upsell add → pipeline do tema ── */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-upsell-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.hasAttribute('disabled')) return;
    // O cart-items lê FormData(form) — inclui properties[_cart_upsell]=1 — faz o add e o re-render.
    document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: btn }, bubbles: false }));
  });

  /* 2b. Upsell: dropdown de variante / irmão → atualiza id, preço e imagem do cartão */
  function money(cents) {
    try { return window.theme.formatMoney(cents, window.theme.moneyFormat); } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-vcz-up-select]');
    if (!sel) return;
    const card = sel.closest('.vcz-up');
    const opt = sel.options[sel.selectedIndex];
    if (!card || !opt) return;
    const idInput = card.querySelector('[data-vcz-up-id]');
    if (idInput) idInput.value = opt.value;
    const priceEl = card.querySelector('[data-vcz-up-price]');
    const price = Number(opt.dataset.price), compare = Number(opt.dataset.compare);
    if (priceEl && price) {
      priceEl.innerHTML = compare > price ? '<b>' + money(price) + '</b> <s>' + money(compare) + '</s>' : money(price);
    }
    const img = card.querySelector('[data-vcz-up-media] img');
    if (img && opt.dataset.image) { img.src = opt.dataset.image; img.removeAttribute('srcset'); }
  });

  /* ── 3. Gift Bag ── */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-vcz-gift-toggle]');
    if (!b || b.hasAttribute('disabled')) return;
    e.preventDefault();
    setLoading();
    try {
      if (b.dataset.lineKey) {
        try { sessionStorage.setItem('vcz_gift_optout', '1'); } catch (err) {}
        await post('/cart/change.js', { id: b.dataset.lineKey, quantity: 0 });
      } else {
        try { sessionStorage.removeItem('vcz_gift_optout'); } catch (err) {}
        await post('/cart/add.js', { items: [{ id: Number(b.dataset.variantId), quantity: 1, properties: { _gift_bag: '1' } }] });
      }
    } catch (err) { console.error('VCZ gift bag:', err); }
    refresh();
  });

  /* ── 4. Discounts ── */
  document.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-vcz-disc-code]');
    if (opt && !opt.disabled) {
      const ci = cartItems();
      if (!ci || typeof ci.updateCartDiscounts !== 'function') return;
      const code = opt.dataset.vczDiscCode;
      if (opt.classList.contains('is-on')) {
        ci.existingDiscountCodes = [];
        ci.updateCartDiscounts('');            // remove
      } else {
        ci.existingDiscountCodes = [code];     // um código de cada vez: substitui o anterior
        ci.updateCartDiscounts(code);
      }
    }
  });
  // "Other code": força um só código (o tema por defeito acumulava a lista)
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-apply-discount]')) {
      const ci = cartItems();
      if (ci) ci.existingDiscountCodes = [];
    }
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      const btn = e.target.closest('.cart__widget--discount')?.querySelector('[data-apply-discount]');
      btn && btn.click();
    }
  });

  /* Discounts: bola no título do acordeão = nº de códigos elegíveis (vem no HTML re-renderizado) */
  function syncDiscountBubble() {
    const n = document.querySelector('[data-vcz-discounts-inner] [data-vcz-disc-count]');
    const b = document.querySelector('[data-vcz-disc-bubble]');
    if (!n || !b) return;
    const v = Number(n.textContent) || 0;
    b.textContent = (b.dataset.template || (window.vczI18n&&window.vczI18n['cart.disc_available_html']) || '[count] available').replace('[count]', v);
    b.hidden = v === 0;
  }

  function syncGift() {
    const st = document.querySelector('[data-vcz-gift-inner] [data-vcz-gift-state]');
    const btn = document.querySelector('[data-vcz-gift-toggle]');
    if (!st || !btn) return;
    const on = st.dataset.on === 'true';
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
    btn.dataset.lineKey = st.dataset.lineKey || '';
    btn.dataset.orphan = st.dataset.orphan || 'false';
    btn.dataset.variantId = st.dataset.variantId || btn.dataset.variantId;
    btn.toggleAttribute('disabled', !(on || st.dataset.available === 'true'));
  }

  /* Gift Bag ligado por predefinição: adiciona sozinho quando há peças no carrinho,
     a não ser que o cliente o tenha desligado nesta sessão (sessionStorage). */
  let giftAutoBusy = false;
  function autoGift() {
    const st = document.querySelector('[data-vcz-gift-inner] [data-vcz-gift-state]');
    const btn = document.querySelector('[data-vcz-gift-toggle]');
    if (!st || !btn || btn.dataset.defaultOn !== 'true' || giftAutoBusy) return;
    if (st.dataset.on === 'true' || st.dataset.available !== 'true') return;
    if (!(Number(st.dataset.others) > 0)) return;
    try { if (sessionStorage.getItem('vcz_gift_optout') === '1') return; } catch (e) {}
    const vid = Number(st.dataset.variantId || btn.dataset.variantId);
    if (!vid) return;
    giftAutoBusy = true;
    post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _gift_bag: '1' } }] })
      .then(() => refresh())
      .catch((err) => { console.error('VCZ gift bag auto:', err); try { sessionStorage.setItem('vcz_gift_optout', '1'); } catch (e) {} })
      .finally(() => { setTimeout(() => { giftAutoBusy = false; }, 1500); });
  }

  /* ── 5. Patch ao build() do cart-items ── */
  function applyFreeShippingLimit(ci) {
    const el = document.querySelector('[data-free-shipping-limit-cents]');
    if (!el || !ci) return;
    const cents = Number(el.dataset.freeShippingLimitCents);
    if (cents > 0) ci.freeShippingLimit = cents;   // já na moeda do mercado — sem × currency.rate
  }

  /* Barra com 2 marcos: envio grátis (limite por país) + oferta (valor único do bloco).
     O tema trata do 1.º marco; aqui corrigimos a % da barra para o 2.º, a mensagem e
     adicionamos/removemos automaticamente o produto-oferta (property _vcz_tier_gift). */
  function fmtMoney(cents) {
    try { return window.theme.formatMoney(cents, window.theme.moneyFormat).replace('.00', '').replace(',00', ''); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function syncTiers(ci, content) {
    const bar = document.querySelector('[data-vcz-tier2-cents]');
    if (!bar || !ci) return;
    const l1 = Number(bar.dataset.freeShippingLimitCents) || 0;
    const l2 = Number(bar.dataset.vczTier2Cents) || 0;
    const sub = Number(ci.subtotal) || 0;
    if (!l2) return;

    const hi = Math.max(l1, l2);
    const lo = Math.min(l1, l2);
    const shipReached = sub >= l1;
    const giftReached = sub >= l2;
    const giftFirst = l2 < l1;
    const giftNext = !giftReached && (giftFirst || shipReached);
    const allReached = shipReached && giftReached;
    bar.classList.toggle('is-ship-reached', shipReached);
    bar.classList.toggle('is-gift-reached', giftReached);
    bar.classList.toggle('is-gift-next', giftNext);
    bar.classList.toggle('is-all-reached', allReached);
    const prog = bar.querySelector('[data-progress-bar]');
    // 1.º marco fixo a 50%: 0→lo = 0→50%, lo→hi = 50→100%
    if (prog) prog.value = Math.min(100, sub <= lo ? (sub / lo) * 50 : 50 + ((sub - lo) / (hi - lo)) * 50);
    bar.querySelectorAll('[data-vcz-mark-cents]').forEach((m) => m.classList.toggle('is-done', sub >= Number(m.dataset.vczMarkCents)));

    const txt = bar.querySelector('[data-vcz-tier2-text]');
    if (txt) {
      if (allReached) txt.textContent = bar.dataset.vczTier2Unlocked || '';
      else if (giftNext) txt.innerHTML = (bar.dataset.vczTier2Msg || '').replace('||amount||', '<span data-vcz-tier2-left>' + fmtMoney(l2 - sub) + '</span>');
      else txt.textContent = '';
    }

    const root = content || document;
    const giftLine = root.querySelector('[data-vcz-tier-gift-key]');
    const variantId = Number(bar.dataset.vczTier2Variant);
    const available = bar.dataset.vczTier2Available === 'true';
    if (ci.__vczTierBusy || !variantId) return;
    if (sub >= l2 && !giftLine && available && ci.cartCount > 0) {
      ci.__vczTierBusy = true;
      post('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _vcz_tier_gift: '1' } }] })
        .catch(() => {}).finally(() => { ci.__vczTierBusy = false; refresh(); });
    } else if (sub < l2 && giftLine) {
      ci.__vczTierBusy = true;
      post('/cart/change.js', { id: giftLine.dataset.vczTierGiftKey, quantity: 0 })
        .catch(() => {}).finally(() => { ci.__vczTierBusy = false; refresh(); });
    }
  }

  // O Broadcast faz `this.build = this.build.bind(this)` no constructor, por isso o patch
  // tem de ser feito NA INSTÂNCIA (um patch só ao prototype nunca chega a correr).
  function afterBuild(ci, content) {
    [['gift', 'gift'], ['discounts', 'discounts']].forEach(([src, dst]) => {
      const from = content && content.querySelector('[data-api-vcz-' + src + ']');
      const to = document.querySelector('[data-vcz-' + dst + '-inner]');
      if (from && to) to.innerHTML = from.innerHTML;
    });
    if (typeof ci.bindDiscountEventListeners === 'function') { try { ci.bindDiscountEventListeners(); } catch (e) {} }
    syncGift();
    autoGift();
    syncDiscountBubble();
    syncTiers(ci, content);
    timer.sync(ci.cartCount);
    // Promo escalonada (vcz-promo.js) — copia as tags re-renderizadas para header + carrinho
    try { document.dispatchEvent(new CustomEvent('vcz:cart:built', { detail: { content: content, cartCount: ci.cartCount } })); } catch (e) {}

    // Gift Bag órfão (só o saco no carrinho) → sai sozinho
    const g = content && content.querySelector('[data-api-vcz-gift] [data-vcz-gift-state]');
    if (g && g.dataset.orphan === 'true' && g.dataset.lineKey && !ci.__vczCleaning) {
      ci.__vczCleaning = true;
      post('/cart/change.js', { id: g.dataset.lineKey, quantity: 0 })
        .catch(() => {})
        .finally(() => { ci.__vczCleaning = false; refresh(); });
    }
  }

  function patchInstance(ci) {
    if (!ci || ci.__vczPatched || typeof ci.build !== 'function') return;
    ci.__vczPatched = true;
    const orig = ci.build;                         // já vem bound à instância
    ci.build = function (content) {
      applyFreeShippingLimit(ci);
      const r = orig.call(ci, content);
      afterBuild(ci, content);
      return r;
    };
    applyFreeShippingLimit(ci);
    try { ci.freeShippingMessageHandle(ci.subtotal); ci.updateProgress(); } catch (e) {}
    syncTiers(ci, null);
  }

  function patchAll() {
    document.querySelectorAll('cart-items').forEach(patchInstance);
  }

  customElements.whenDefined('cart-items').then(() => {
    patchAll();
    // Instâncias futuras (editor de tema / re-render de secção)
    const CI = customElements.get('cart-items');
    if (CI && !CI.prototype.__vczCC) {
      CI.prototype.__vczCC = true;
      const origCC = CI.prototype.connectedCallback;
      CI.prototype.connectedCallback = function () {
        if (origCC) origCC.call(this);
        patchInstance(this);
      };
    }
  });

  /* ── 6. Contador de reserva ── */
  const timer = (() => {
    const KEY = 'vcz_cart_reserved_until';
    let iv = null;
    const el = () => document.querySelector('[data-vcz-timer]');
    const read = () => { try { return Number(sessionStorage.getItem(KEY) || 0); } catch (e) { return 0; } };
    const write = (v) => { try { v ? sessionStorage.setItem(KEY, String(v)) : sessionStorage.removeItem(KEY); } catch (e) {} };

    function tick() {
      const e = el();
      if (!e) return;
      const left = read() - Date.now();
      if (left <= 0) { e.hidden = true; if (iv) { clearInterval(iv); iv = null; } return; }
      e.hidden = false;
      const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      const tpl = e.dataset.template || '[time]';
      const out = e.querySelector('[data-vcz-timer-text]');
      if (out) out.textContent = tpl.replace('[time]', m + ':' + String(s).padStart(2, '0'));
      if (!iv) iv = setInterval(tick, 1000);
    }
    function sync(count) {
      const e = el();
      if (!e) return;
      if (!(count > 0)) { write(0); e.hidden = true; if (iv) { clearInterval(iv); iv = null; } return; }
      if (!read()) write(Date.now() + (Number(e.dataset.minutes) || 10) * 60000);   // arranca 1 vez por sessão
      tick();
    }
    return { sync };
  })();

  function initialCount() {
    const cc = document.querySelector('cart-count');
    if (cc && cc.hasAttribute('data-cart-count')) return Number(cc.getAttribute('data-cart-count')) || 0;
    return (window.theme && window.theme.subtotal > 0) ? 1 : 0;
  }
  document.addEventListener('theme:cart:change', (e) => timer.sync(e.detail && e.detail.cartCount));

  /* ── 7. Data estimada de envio ── */
  function shipDate() {
    const el = document.querySelector('[data-vcz-shipdate]');
    if (!el) return;
    const cutoff = Number(el.dataset.cutoff || 14);
    const lead = Math.max(0, Number(el.dataset.lead || 2));
    const tz = el.dataset.tz || 'Europe/Lisbon';
    const holidays = (el.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean);

    // "agora" em Lisboa
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit' })
        .formatToParts(new Date()).map((p) => [p.type, p.value])
    );
    let d = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day));
    const hour = Number(parts.hour) % 24;
    const iso = (x) => x.toISOString().slice(0, 10);
    const isBiz = (x) => { const w = x.getUTCDay(); return w !== 0 && w !== 6 && !holidays.includes(iso(x)); };
    const nextBiz = (x) => { do { x.setUTCDate(x.getUTCDate() + 1); } while (!isBiz(x)); return x; };

    if (hour >= cutoff) d.setUTCDate(d.getUTCDate() + 1);   // depois do corte → conta a partir de amanhã
    if (!isBiz(d)) nextBiz(d);                                // fim de semana / feriado → 1.º dia útil
    for (let i = 0; i < lead; i++) nextBiz(d);               // + N dias úteis

    const fmt = el.dataset.format === 'short'
      ? { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }
      : { day: 'numeric', month: 'long', timeZone: 'UTC' };
    const out = el.querySelector('[data-vcz-shipdate-value]');
    // Nomes de mês/dia na língua da loja (<html lang="{{ request.locale.iso_code }}">); 'en' como antes se faltar/for inválida
    let dtf;
    try { dtf = new Intl.DateTimeFormat(document.documentElement.lang || 'en', fmt); } catch (e) { dtf = new Intl.DateTimeFormat('en', fmt); }
    if (out) out.textContent = dtf.format(d);
  }

  /* ── 8. Compatibilidade com o personalizador ──
     O personalizador (v1.7+) faz POST /cart/add.js com { items: [peça, corrente shadow, add-ons] }
     mas (a) não põe a property _vcz_group que liga os itens e (b) não dispara theme:cart:refresh,
     por isso o drawer não atualizava nem mostrava as sub-linhas. Em vez de depender de cada versão
     do personalizador, intercetamos aqui o fetch: injetamos um _vcz_group comum quando há 2+ itens
     sem grupo e, com a resposta OK, refrescamos o cart-items (que re-renderiza e abre o drawer). */
  (function () {
    if (typeof window.fetch !== 'function' || window.fetch.__vczCompat) return;
    const origFetch = window.fetch;
    const isAddUrl = (u) => /\/cart\/add(\.js)?(\?|$)/.test(String(u));
    const urlOf = (input) => (typeof input === 'string' ? input : (input && input.url) || '');
    const internal = (it) => it && it.properties && (it.properties._gift_bag || it.properties._vcz_tier_gift || it.properties._cart_upsell);

    const patched = function (input, init) {
      let personalizerAdd = false;
      try {
        const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && isAddUrl(urlOf(input)) && init && typeof init.body === 'string') {
          const data = JSON.parse(init.body);
          if (data && Array.isArray(data.items) && data.items.length && !data.items.every(internal)) {
            personalizerAdd = true;
            const hasGroup = data.items.some((it) => it && it.properties && it.properties._vcz_group);
            if (!hasGroup && data.items.length > 1) {
              const gid = 'vcz-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
              data.items.forEach((it) => { if (it) it.properties = Object.assign({}, it.properties || {}, { _vcz_group: gid }); });
              init = Object.assign({}, init, { body: JSON.stringify(data) });
            }
          }
        }
      } catch (e) { /* body não é JSON — segue sem alterações */ }

      const p = origFetch.call(this, input, init);
      if (personalizerAdd) {
        p.then((res) => { if (res && res.ok) setTimeout(refresh, 60); }).catch(() => {});
      }
      return p;
    };
    patched.__vczCompat = true;
    window.fetch = patched;
  })();

  /* ── 9. Moeda do carrinho ≠ moeda da página ── [20/10/2026]
     Quando o cookie de localização (mercado) não bate certo com o mercado do URL (ex.: cliente que
     caiu primeiro na loja US pelo link do anúncio e só depois passou para /pt-pt), a página mostra €
     mas os pedidos do carrinho (/cart.js, secção api-cart-items) obedecem ao cookie: o drawer aparece
     em $ com portes dos EUA. Guarda: ao arrancar, compara Shopify.currency.active com a moeda do
     carrinho; se forem diferentes, reafirma o país da página no endpoint /localization (reescreve o
     cookie e o Shopify converte o carrinho) e refresca o drawer. Corre no máximo 1 vez por página. */
  const currencyGuard = (() => {
    let done = false;
    const root = () => {
      const r = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
      return r.endsWith('/') ? r : r + '/';
    };
    const getCart = () => fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
    async function run() {
      if (done) return;
      const S = window.Shopify || {};
      const pageCur = S.currency && S.currency.active;
      const country = S.country;
      if (!pageCur || !country) return;
      done = true;
      try {
        const cart = await getCart();
        if (!cart || !cart.currency || cart.currency === pageCur) return;
        const fd = new URLSearchParams({ form_type: 'localization', utf8: '✓', _method: 'put', country_code: country, return_to: location.pathname });
        await fetch(root() + 'localization', { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'manual' });
        const after = await getCart();
        if (after && after.currency === pageCur) refresh();
      } catch (e) { /* silencioso: o pior caso é ficar como estava */ }
    }
    return { run };
  })();

  /* ── init ── */
  function init() {
    currencyGuard.run();
    shipDate();
    timer.sync(initialCount());
    patchAll();
    syncGift();
    autoGift();
    syncDiscountBubble();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
